@if (dataLoaded) {
  @if (!isLinkExpired && objectId) {
    <div class="main-wrapper-third-party">
      <header class="main-header">
        @if (logoUrl) {
          <img [src]="logoUrl"
            alt="logo" />
        }
        @if (!logoUrl) {
          <mat-icon [svgIcon]="'xa-logo-white'"
          ></mat-icon>
        }
      </header>
      <div class="container">
        <div class="card">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
    @if (claimDetails) {
      <chq-pdf-generator
        class="margin-pdf"
        #elementRef
        [isClaim]="isClaimModule"
        [claimDetail]="claimDetails"
        [damageParts]='damageParts'
        [damageRecommendations]="damageRecommendationList"
      [uploadSteps]="pdfImageSteps"></chq-pdf-generator>
    }
  } @else {
    <div class="link-expired-container">
      <div class="card">
        <div class="title-container fx-col gap-10 text-center">
          <div class="title">{{'sorry' | translate}}</div>
          <div class="sub-title">{{'link_expired' | translate}}</div>
        </div>
      </div>
    </div>
  }
}